import { memo, useMemo } from "react";

import Typography from "ds/components/Typography";

import { type RenderGroupRowCellProps } from ".";
import { ResourcesSuggestions } from "../../useIacManagementFilters/constants";
import useCellCopyAction from "../useCellCopyAction";
import IacManagementGroupCell from "../components/GroupCell";

const IacManagementTableGroupRowCellResourcesCount = memo((props: RenderGroupRowCellProps) => {
  const { row } = props;

  const copyAction = useCellCopyAction(ResourcesSuggestions.ResourcesCount, row.count.toString());
  const actions = useMemo(() => [copyAction], [copyAction]);

  return (
    <IacManagementGroupCell {...props} actions={actions}>
      <Typography variant="p-body3" tag="span">
        {row.count}
      </Typography>
    </IacManagementGroupCell>
  );
});

IacManagementTableGroupRowCellResourcesCount.displayName =
  "IacManagementTableGroupRowCellResourcesCount";

export default IacManagementTableGroupRowCellResourcesCount;
